import React, { useContext, useEffect, useState } from "react";
import { Link, Routes, useParams, useNavigate } from "react-router-dom";
import ImageWithBasePath from "../core/common/imageWithBasePath";
import { all_routes } from "./router/all_routes";
import Header from "./Header";
import { ProductContext } from "../context/AppContext";
import jsPDF from "jspdf";
// import "jspdf-autotable";
import moment from "moment";
import Swal from "sweetalert2";
import { Button } from "antd";
import { QRCodeCanvas } from "qrcode.react";

const MyEnquiry = () => {
  const params = useParams();
  const [state, setState] = useState(null);
  const navigate = useNavigate();
  const {
    session = [],
    allClass = [],
    getenquiry,
    setGetEnquiry,
    dataNew,
    fetchUserProfileData,
    Automationdata,
  } = useContext(ProductContext);

  const schoolAutomation = Automationdata?.data?.[0];

  const routes = all_routes;
  const { id } = useParams();
  const authtoken = localStorage.getItem("token");
  useEffect(() => {
    fetchUserProfileData();
  }, []);

  const ClassdataNew = {
    class: Number(dataNew?.class),
  };

  const ClassLabel = allClass
    .filter((item) => item.value === ClassdataNew.class)
    .map((item) => item.label)[0];

  console.log(Automationdata?.data?.[0]?.schoolLogo, "schoolLogo");

  const printEnquiryForm = async () => {
    // Create a new window for printing
    const printWindow = window.open("", "_blank");
    const timestamp = moment().format("YYYY-MM-DD HH:mm:ss");

    // Build HTML content for printing
    let printContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <title>${dataNew?.student_full_name}</title>
      <style>
      body { 
        font-family: Arial, sans-serif; 
        margin: 20px; 
        color: #333;
      }
      .header { 
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 30px;
        border-bottom: 2px solid #0052cc;
        padding-bottom: 20px;
      }
      .school-logo-container {
        flex: 0 0 auto;
      }
      .school-logo {
        max-width: 120px;
        max-height: 120px;
        object-fit: contain;
      }
      .school-info {
        flex: 1;
        text-align: center;
        padding: 0 20px;
      }
      .school-name { 
        font-size: 24px; 
        font-weight: bold; 
        color:rgb(0, 0, 0);
        margin-bottom: 10px;
      }
      .school-details { 
        font-size: 14px; 
        color: #666;
        margin-bottom: 5px;
      }
      .timestamp {
        flex: 0 0 auto;
        text-align: right;
        font-size: 12px;
        color: #888;
      }
      .section { 
        margin: 20px 0; 
      }
      .section-title { 
        background-color: #f8f9fa; 
        padding: 10px; 
        font-weight: bold; 
        border-left: 4px solid #0052cc;
        margin-bottom: 15px;
      }
      .child-section {
        margin: 25px 0;
        padding: 15px;
        border: 1px solid #ddd;
        border-radius: 8px;
      }
      .row { 
        display: flex; 
        flex-wrap: wrap; 
        margin: 0 -10px;
      }
      .col { 
        flex: 1; 
        min-width: 250px; 
        padding: 0 10px; 
        margin-bottom: 10px;
      }
      .label { 
        font-weight: bold; 
        color: #555;
        margin-bottom: 5px;
      }
      .value { 
        margin-bottom: 12px;
      }
      .transport-fees {
        background-color: #f8f9fa;
        padding: 15px;
        border-radius: 6px;
        margin-top: 10px;
      }
      .footer {
        margin-top: 30px;
        padding-top: 20px;
        border-top: 1px solid #ddd;
        font-size: 12px;
        color: #666;
        text-align: center;
      }
      .qr-code-section {
        text-align: center;
        margin: 20px 0;
        padding: 15px;
        border: 1px solid #ddd;
        border-radius: 8px;
        background: #f8f9fa;
      }
      .qr-code-image {
        width: 150px;
        height: 150px;
        margin: 10px auto;
        display: block;
      }
      @media print {
        body { margin: 0; }
        .no-print { display: none; }
        .header { 
          page-break-after: avoid; 
          break-after: avoid;
        }
        .child-section { 
          page-break-inside: avoid; 
          break-inside: avoid;
        }
      }
    </style>
    </head>
    <body>
  `;

    // Add school header
    if (schoolAutomation) {
      printContent += `
    <div class="header">
      <div class="school-logo-container">
        ${
          schoolAutomation.schoolLogo
            ? `<img src="${schoolAutomation.schoolLogo}" alt="School Logo" class="school-logo" />`
            : '<div style="width: 120px; height: 120px; background: #f0f0f0; display: flex; align-items: center; justify-content: center; color: #999;">No Logo</div>'
        }
      </div>
      <div class="school-info">
        <div class="school-name">${
          schoolAutomation.schoolName || "School Enquiry Form"
        }</div>
        ${
          schoolAutomation.schoolAddress
            ? `<div class="school-details">${schoolAutomation.schoolAddress}</div>`
            : ""
        }
        ${
          schoolAutomation.contact_number
            ? `<div class="school-details">Contact: ${schoolAutomation.contact_number}</div>`
            : ""
        }
        ${
          schoolAutomation.email
            ? `<div class="school-details">Email: ${schoolAutomation.email}</div>`
            : ""
        }
        <div class="school-details">Session: ${
          dataNew?.session_data?.Name
        }</div>
      </div>
      <div class="timestamp">
        Generated on:<br/>${timestamp}
      </div>
    </div>
  `;
    } else {
      printContent += `
      <div class="header">
        <div class="school-name">Enquiry Form</div>
        <div class="school-details">Generated on: ${timestamp}</div>
      </div>
    `;
    }

    // Add children data

    printContent += `

      <div class="child-section">
        
        <div class="section">
          <div class="section-title" style="font-size: 16px;">Student Information</div>
          <div class="row">
            <div class="col">
              <div class="label">Full Name</div>
              <div class="value">${dataNew?.student_full_name || "N/A"}</div>
            </div>
            <div class="col">
              <div class="label">Date of Birth</div>
              <div class="value">${dataNew?.dob || "N/A"}</div>
            </div>
            <div class="col">
              <div class="label">Class</div>
              <div class="value">${dataNew?.class_data?.Classes}</div>
            </div>
            <div class="col">
              <div class="label">Gender</div>
              <div class="value">${dataNew?.gender || "N/A"}</div>
            </div>
          
          <div class="col">
              <div class="label">Session</div>
              <div class="value">${dataNew?.session_data?.Name}</div>
            </div>
          
          <div class="col">
              <div class="label">Enquiry Source</div>
              <div class="value">${dataNew?.enquirysources || "N/A"}</div>
            </div>
             <div class="col">
              <div class="label">Transport</div>
              <div class="value">${
                dataNew?.is_transport === true
                  ? "Yes"
                  : dataNew?.is_transport === false
                  ? "No"
                  : "N/A"
              }</div>
            </div>
         
            
            

          </div>
        </div>

        <div class="section">
          <div class="section-title" style="font-size: 16px;">Parent Information</div>
          <div class="row">
          ${
            dataNew?.fathername
              ? `
          <div class="col">
              <div class="label">Father Full Name</div>
              <div class="value">${dataNew?.fathername || "N/A"}</div>
            </div>
            `
              : ""
          }
            ${
              dataNew?.mothername
                ? `
             <div class="col">
              <div class="label">Mother Full Name</div>
              <div class="value">${dataNew?.mothername || "N/A"}</div>
            </div>
            `
                : ""
            }

            ${
              dataNew?.guardian_name
                ? `
             <div class="col">
              <div class="label">Guardian Full Name</div>
              <div class="value">${dataNew?.guardian_name || "N/A"}</div>
            </div>
            `
                : ""
            }
            ${
              dataNew?.guardian_relation
                ? `
            <div class="col">
              <div class="label">Relation</div>
              <div class="value">${dataNew?.guardian_relation || "N/A"}</div>
            </div>
            `
                : ""
            }
            ${
              dataNew?.contactno
                ? `
            <div class="col">
              <div class="label">Contact No.</div>
              <div class="value">${dataNew?.contactno || "N/A"}</div>
            </div>
            `
                : ""
            }
            ${
              dataNew?.mother_contact_no
                ? `
            <div class="col">
              <div class="label">Mother Contact No.</div>
              <div class="value">${dataNew?.mother_contact_no || "N/A"}</div>
            </div>
            `
                : ""
            }
            ${
              dataNew?.guardian_mobile_no
                ? `
            <div class="col">
              <div class="label">Guardian Contact No.</div>
              <div class="value">${dataNew?.guardian_mobile_no || "N/A"}</div>
            </div>
            `
                : ""
            }
            ${
              dataNew?.primary_contact_no
                ? `
            <div class="col">
              <div class="label">Primary Contact No.</div>
              <div class="value">${dataNew?.primary_contact_no || "N/A"}</div>
            </div>
            `
                : ""
            }
            ${
              dataNew?.emailid
                ? `
            <div class="col">
              <div class="label">Email</div>
              <div class="value">${dataNew?.emailid || "N/A"}</div>
            </div>
            `
                : ""
            }
            

            
          </div>
          
        </div>

        
        
    `;

    // Add Associated Member Details (if any referrals exist)
    let referralsHtml = "";
    if (Array.isArray(dataNew?.referrals) && dataNew.referrals.length > 0) {
      referralsHtml += `
    <div class="section">
      <div class="section-title" style="font-size: 16px;">Associated Member Details</div>
  `;

      referralsHtml += dataNew.referrals
        .map((referencedata, index) => {
          return `
        <div class="child-section">
          <div class="row">
            ${
              referencedata?.ref_admission_no
                ? `
              <div class="col">
                <div class="label">Admission Number</div>
                <div class="value">${referencedata.ref_admission_no}</div>
              </div>`
                : ""
            }
            ${
              referencedata?.ref_employee_code
                ? `
              <div class="col">
                <div class="label">Employee Code</div>
                <div class="value">${referencedata.ref_employee_code}</div>
              </div>`
                : ""
            }
              ${
                referencedata?.ref_name
                  ? `
              <div class="col">
                <div class="label">Name</div>
                <div class="value">${referencedata.ref_name}</div>
              </div>`
                  : ""
              }
            ${
              referencedata?.ref_contact_no
                ? `
              <div class="col">
                <div class="label">Number</div>
                <div class="value">${referencedata.ref_contact_no}</div>
              </div>`
                : ""
            }
            ${
              referencedata?.ref_role
                ? `
              <div class="col">
                <div class="label">Role</div>
                <div class="value">${referencedata.ref_role}</div>
              </div>`
                : ""
            }
              ${
                referencedata?.ref_year_of_leaving
                  ? `
              <div class="col">
                <div class="label">Leaving Year</div>
                <div class="value">${referencedata.ref_year_of_leaving}</div>
              </div>`
                  : ""
              }
              
            ${
              referencedata?.ref_note
                ? `
              <div class="col">
                <div class="label">Note</div>
                <div class="value">${referencedata.ref_note}</div>
              </div>`
                : ""
            }
          </div>
        </div>
      `;
        })
        .join("");

      referralsHtml += `</div>`; // close section
    }

    // 🔹 Append referralsHtml into printContent
    printContent += referralsHtml;

    // Add QR Code to print content
    // Add QR Code to print content
    const getQRCodeDataURL = () => {
      const canvas = document.querySelector("canvas");
      if (canvas) {
        return canvas.toDataURL("image/png");
      }
      return null;
    };
    const qrCodeDataURL = getQRCodeDataURL();
    printContent += `
  <div class="section">
    <div class="section-title" style="font-size: 16px;">Fee Structure QR Code</div>
    <div style="text-align: center; margin: 20px 0;">
      <p>Scan the QR code below to view the complete fee structure:</p>
      <div style="display: inline-block; padding: 10px; background: white; border: 1px solid #ddd;">
        ${
          qrCodeDataURL
            ? `<img src="${qrCodeDataURL}" alt="Fee Structure QR Code" style="width: 150px; height: 150px;" />`
            : `<div style="width: 150px; height: 150px; background: #f8f9fa; display: flex; align-items: center; justify-content: center; margin: 0 auto; color: #666;">
            QR Code<br/>Not Available
          </div>`
        }
      </div>
      <p style="font-size: 12px; color: #666; margin-top: 10px;">
        URL: ${window.location.origin}/documentdownload
      </p>
    </div>
  </div>
`;

    // Add Admission Process Steps to print content
    if (schoolAutomation?.doc_info) {
      printContent += `
    <div class="section">
      <div class="section-title" style="font-size: 16px;">Admission Process</div>
      <div style="padding: 15px; background: #f8f9fa; border-radius: 6px;">
  `;

      Object.entries(JSON.parse(schoolAutomation.doc_info)).forEach(
        ([key, value]) => {
          printContent += `
      <div style="margin-bottom: 20px;">
        <h4 style="color: #0052cc; margin-bottom: 10px;">${key}</h4>
        <div style="font-size: 14px; line-height: 1.5;">
          ${value.replace(/\\n/g, "<br/>").replace(/\n/g, "<br/>")}
        </div>
      </div>
    `;
        }
      );

      printContent += `
      </div>
    </div>
  `;
    }
    printContent += `
        </div>
      </div>
    `;

    // Add footer
    printContent += `
      <div class="footer">
        <div>Generated on: ${timestamp}</div>
        <div>This is a computer-generated enquiry form.</div>
      </div>
      
      <div class="no-print" style="text-align: center; margin-top: 20px;">
        <button onclick="window.print()" style="padding: 10px 20px; background: #007bff; color: white; border: none; border-radius: 5px; cursor: pointer;">Print Form</button>
        <button onclick="window.close()" style="padding: 10px 20px; background: #6c757d; color: white; border: none; border-radius: 5px; cursor: pointer; margin-left: 10px;">Close</button>
      </div>
    </body>
    </html>
  `;

    // Write content to print window
    printWindow.document.write(printContent);
    printWindow.document.close();

    // Focus on the print window
    printWindow.focus();

    Swal.fire({
      icon: "success",
      title: "Print Ready",
      text: "The enquiry form is ready for printing. Use the print button in the new window.",
    });
  };

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        {dataNew ? (
          <div className="content" id="enquiry-content">
            <div className="row">
              <Header hideSearch={true} />
              <div className="col-md-12">
                <div className="d-md-flex d-block align-items-center justify-content-between mt-2 mb-2">
                  <div className="my-auto mb-2" style={{ width: "100%" }}>
                    <h2
              className="page-title fw-bold mb-0"
              style={{ letterSpacing: "0.5px" }}>
                      Enquiry Details

                      
                      <span style={{ float: "right" }}>
                        <Link to = ""
                          type="button"
                          onClick={printEnquiryForm}
                          // disabled={loading}
                          className="btn btn-outline-primary"
                        >
                          Download PDF
                        </Link>
                      </span>
                    </h2>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-xxl-3 col-xl-4 theiaStickySidebar">
                <div className="stickybar pb-4">
                  <div className="card border-white">
                    <div className="card-body">
                      <h5 className="mb-3">Student Information</h5>
                      <dl className="row mb-0">
                        <dt className="col-6 fw-medium text-dark mb-3">
                          Session
                        </dt>
                        <dd className="col-6 mb-3">
                          {dataNew?.session_data?.Name}
                        </dd>
                        <dt className="col-6 fw-medium text-dark mb-3">
                          Student Name
                        </dt>
                        <dd className="col-6 mb-3">
                          {dataNew?.student_full_name}
                        </dd>
                        <dt className="col-6 fw-medium text-dark mb-3">
                          User Name
                        </dt>
                        <dd className="col-6 mb-3">{dataNew?.username}</dd>

                        <dt className="col-6 fw-medium text-dark mb-3">
                          Class
                        </dt>
                        <dd className="col-6 mb-3">
                          {dataNew?.class_data?.Classes}
                        </dd>

                        {/* <dt className="col-6 fw-medium text-dark mb-3">Number</dt>
                      <dd className="col-6 mb-3">{dataNew?.id}</dd> */}
                        <dt className="col-6 fw-medium text-dark mb-3">
                          Gender
                        </dt>
                        <dd className="col-6 mb-3">{dataNew?.gender}</dd>

                        <dt className="col-6 fw-medium text-dark mb-3">DOB</dt>
                        <dd className="col-6 mb-3">{dataNew?.dob}</dd>

                        <dt className="col-6 fw-medium text-dark mb-3">
                          Enquiry Source
                        </dt>
                        <dd className="col-6 mb-3">
                          {dataNew?.enquirysources}
                        </dd>

                        <dt className="col-6 fw-medium text-dark mb-3">
                          Enquiry Date
                        </dt>
                        <dd className="col-6 mb-3">
                          {dataNew?.enquirydatetime
                            ? new Date(dataNew?.enquirydatetime)
                                .toISOString()
                                .split("T")[0]
                            : "N/A"}
                        </dd>

                        <dt className="col-6 fw-medium text-dark mb-3">
                          Transport
                        </dt>
                        <dd className="col-6 mb-3">
                          {dataNew?.is_transport === true
                            ? "Yes"
                            : dataNew?.is_transport === false
                            ? "No"
                            : "N/A"}
                        </dd>
                      </dl>
                      <QRCodeCanvas
                        value={`${window.location.origin}/documentdownload`}
                        size={256}
                        level="H"
                        includeMargin={true}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xxl-9 col-xl-8">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-header">
                        <h5>
                          Parents Information
                          {getenquiry?.data[0]?.is_registered === false ? (
                          <span className="create_registraion_1">
                            <Link
                              to={{
                                pathname: routes.createregistration,
                                state: { class: ClassdataNew.class },
                              }}
                            >
                              Apply Registration
                            </Link>
                          </span>
                           ) : null}
                        </h5>
                      </div>
                      <div className="card-body">
                        <div className="border rounded p-3 pb-0 mb-3">
                          <div className="row">
                            {dataNew?.fathername && (
                              <div className="col-sm-6 col-lg-3">
                                <div className="mb-3">
                                  <div className="">
                                    <h6 className="text-dark fw-medium mb-1">
                                      Father Name
                                    </h6>
                                    <p className="">{dataNew?.fathername}</p>
                                  </div>
                                </div>
                              </div>
                            )}

                            {dataNew?.mothername && (
                              <div className="col-lg-3 col-sm-6 ">
                                <div className="mb-3">
                                  <div className="">
                                    <h6 className="text-dark fw-medium mb-1">
                                      Mother Name
                                    </h6>
                                    <p className="">{dataNew?.mothername}</p>
                                  </div>
                                </div>
                              </div>
                            )}
                            {dataNew?.guardian_name && (
                              <div className="col-lg-3 col-sm-6 ">
                                <div className="mb-3">
                                  <div className="">
                                    <h6 className="text-dark fw-medium mb-1">
                                      Guardian Name
                                    </h6>
                                    <p className="">{dataNew?.guardian_name}</p>
                                  </div>
                                </div>
                              </div>
                            )}
                            {dataNew?.guardian_relation && (
                              <div className="col-lg-3 col-sm-6 ">
                                <div className="mb-3">
                                  <div className="">
                                    <h6 className="text-dark fw-medium mb-1">
                                      Guardian Relation
                                    </h6>
                                    <p className="">
                                      {dataNew?.guardian_relation}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            )}
                            {dataNew?.contactno && (
                              <div className="col-sm-6 col-lg-3">
                                <div className="mb-3">
                                  <p className="text-dark fw-medium mb-1">
                                    Father Number
                                  </p>
                                  <p>{dataNew?.contactno}</p>
                                </div>
                              </div>
                            )}
                            {dataNew?.mother_contact_no && (
                              <div className="col-sm-6 col-lg-3">
                                <div className="mb-3">
                                  <p className="text-dark fw-medium mb-1">
                                    Mother Number
                                  </p>
                                  <p>{dataNew?.mother_contact_no}</p>
                                </div>
                              </div>
                            )}
                            {dataNew?.guardian_mobile_no && (
                              <div className="col-sm-6 col-lg-3">
                                <div className="mb-3">
                                  <p className="text-dark fw-medium mb-1">
                                    Guardian Number
                                  </p>
                                  <p>{dataNew?.guardian_mobile_no}</p>
                                </div>
                              </div>
                            )}
                            {dataNew?.primary_contact_no && (
                              <div className="col-sm-6 col-lg-3">
                                <div className="mb-3">
                                  <p className="text-dark fw-medium mb-1">
                                    Primary Contact
                                  </p>
                                  <p>{dataNew?.primary_contact_no}</p>
                                </div>
                              </div>
                            )}
                            <div className="col-sm-6 col-lg-3">
                              <div className="d-flex align-items-center justify-content-between">
                                <div className="mb-3 overflow-hidden me-3">
                                  <p className="text-dark fw-medium mb-1">
                                    Email
                                  </p>
                                  <p className="text-truncate">
                                    {dataNew?.emailid}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {dataNew?.referrals && dataNew?.referrals?.length > 0 ? (
                  <div className="row">
                    <div className="col-md-12">
                      <div className="card">
                        <div className="card-header">
                          <h5>Associated Member Details</h5>
                        </div>
                        <div className="card-body">
                          <div className="border rounded p-3 pb-0 mb-3">
                            {dataNew?.referrals?.map((referencedata, index) => {
                              return (
                                <div className="row">
                                  {referencedata?.ref_admission_no && (
                                    <div className="col-sm-6 col-lg-3">
                                      <div className="mb-3">
                                        <div className="">
                                          <h6 className="text-dark fw-medium mb-1">
                                            Admission Number
                                          </h6>
                                          <p className="">
                                            {referencedata?.ref_admission_no}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {referencedata?.ref_employee_code && (
                                    <div className="col-sm-6 col-lg-3">
                                      <div className="mb-3">
                                        <div className="">
                                          <h6 className="text-dark fw-medium mb-1">
                                            Employee Code
                                          </h6>
                                          <p className="">
                                            {referencedata?.ref_employee_code}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {referencedata?.ref_name && (
                                    <div className="col-sm-6 col-lg-3">
                                      <div className="mb-3">
                                        <div className="">
                                          <h6 className="text-dark fw-medium mb-1">
                                            Name
                                          </h6>
                                          <p className="">
                                            {referencedata?.ref_name}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {referencedata?.ref_contact_no && (
                                    <div className="col-sm-6 col-lg-3">
                                      <div className="mb-3">
                                        <div className="">
                                          <h6 className="text-dark fw-medium mb-1">
                                            Number
                                          </h6>
                                          <p className="">
                                            {referencedata?.ref_contact_no}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {referencedata?.ref_role && (
                                    <div className="col-sm-6 col-lg-3">
                                      <div className="mb-3">
                                        <div className="">
                                          <h6 className="text-dark fw-medium mb-1">
                                            Role
                                          </h6>
                                          <p className="">
                                            {referencedata?.ref_role}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {referencedata?.ref_relation && (
                                    <div className="col-sm-6 col-lg-3">
                                      <div className="mb-3">
                                        <div className="">
                                          <h6 className="text-dark fw-medium mb-1">
                                            Relation
                                          </h6>
                                          <p className="">
                                            {referencedata?.ref_relation}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {referencedata?.ref_year_of_leaving && (
                                    <div className="col-sm-6 col-lg-3">
                                      <div className="mb-3">
                                        <div className="">
                                          <h6 className="text-dark fw-medium mb-1">
                                            Leaving Year
                                          </h6>
                                          <p className="">
                                            {referencedata?.ref_year_of_leaving}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {referencedata?.ref_note && (
                                    <div className="col-sm-6 col-lg-3">
                                      <div className="mb-3">
                                        <div className="">
                                          <h6 className="text-dark fw-medium mb-1">
                                            Note
                                          </h6>
                                          <p className="">
                                            {referencedata?.ref_note}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        ) : (
          <div className="content row d-flex justify-content-center align-items-center background-color_row_1">
            <Header />
            <ImageWithBasePath
              src="assets/img/nodata.gif"
              className="img-fluid"
              alt="img"
              width={200}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default MyEnquiry;
